import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown } from "react-bootstrap";
import { saveAs } from "file-saver";
import { pdf } from "@react-pdf/renderer";
import moment from "moment";
import styled from "@emotion/styled";
import { storeOperations, storeSelector } from "state/ducks/store";
import PdfStockSingleDay from "./PdfStockSingleDay";

const PdfButtonSingleDay = props => {
  const { establishmentId, types, categoriesFilter, selectedDate } = props;

  const [loadPdf, setLoadPdf] = useState(false);

  // Cherche les stocks et le détail de l'établissement
  const forecastStocks = useSelector(state => {
    return storeSelector.getForecastStocksPrintSelector(state);
  });
  const establishment = useSelector(state => state.session.establishment);

  const dispatch = useDispatch();

  /**
   * Lance la requete pour les forecast stock pour une seule journée
   */
  const generatePdf = () => {
    let categoriesTransform = [];
    if (categoriesFilter) {
      categoriesFilter.forEach((category, key) => {
        categoriesTransform = [...categoriesTransform, category.value];
      });
    }

    setLoadPdf(true);
    
    // Calculer le numéro de semaine à partir de la date sélectionnée
    const selectedMoment = moment(selectedDate);
    const currentWeek = moment().week();
    const selectedWeek = selectedMoment.week();
    const weekOffset = selectedWeek - currentWeek;

    dispatch(
      storeOperations.getForecastStocks(
        establishmentId,
        types,
        categoriesTransform,
        [weekOffset],
        [selectedMoment.day()], // Seulement le jour sélectionné
        0,
        null,
        true,
        true
      )
    );
  };

  useEffect(() => {
    if (
      loadPdf === true &&
      forecastStocks.printData &&
      forecastStocks.printData.length > 0 &&
      forecastStocks.isLoading === false
    ) {
      const selectedMoment = moment(selectedDate);
      const formattedDate = selectedMoment.format("DD-MM-YYYY");
      const dayName = selectedMoment.format("dddd");
      
      const fileName =
        "besoin-produit-" +
        (establishment === 1 ? "L": "V")  +
        "-" +
        dayName.toLowerCase() +
        "-" +
        formattedDate +
        ".pdf";
        
      const blob = pdf(
        <>
        <PdfStockSingleDay
          stocksProduct={forecastStocks}
          selectedDate={formattedDate}
        />
        </>
      ).toBlob();
      blob.then(pdfBlob => {
        setLoadPdf(false);
        saveAs(pdfBlob, fileName);
      });
    }
  }, [loadPdf, establishment, forecastStocks, selectedDate]);

  return (
    <div>
      {!loadPdf ? (
        <Item onClick={generatePdf}>
          Générer PDF pour le {moment(selectedDate).format("DD/MM/YYYY")}
        </Item>
      ) : (
        "Géneration du pdf en cours..."
      )}
    </div>
  );
};

const Item = styled(Dropdown.Item)`
  border-bottom: solid 1px #ccc;
  &:hover {
    background-color: #ddd;
  }
`;

PdfButtonSingleDay.propTypes = {
  establishmentId: PropTypes.string, // Id de l'établissent
  types: PropTypes.array, // Liste des types d'activité pour les stocks
  categoriesFilter: PropTypes.array, // La valeur du filtre catégorie
  selectedDate: PropTypes.string.isRequired // Date sélectionnée (format YYYY-MM-DD)
};

export default PdfButtonSingleDay;
